var API_PREFIX = "/api";

export async function login(payload) {
  return request("/auth/login", {
    method: "POST",
    body: payload,
    auth: false
  });
}

export async function sendRegisterSmsCode(payload) {
  return request("/auth/register/sms-code", {
    method: "POST",
    body: payload,
    auth: false
  });
}

export async function register(payload) {
  return request("/auth/register", {
    method: "POST",
    body: payload,
    auth: false
  });
}

export async function getCurrentUser(token) {
  return request("/auth/me", {
    method: "GET",
    token: token
  });
}

export async function refreshToken(token) {
  return request("/auth/refresh", {
    method: "POST",
    token: token
  });
}

export async function logout(token) {
  return request("/auth/logout", {
    method: "POST",
    token: token
  });
}

async function request(path, options) {
  var settings = options || {};
  var headers = {
    Accept: "application/json",
    "Content-Type": "application/json"
  };

  if (settings.auth !== false && settings.token) {
    headers.Authorization = "Bearer " + settings.token;
  }

  var response = await fetch(API_PREFIX + path, {
    method: settings.method || "GET",
    headers: headers,
    body: settings.body ? JSON.stringify(settings.body) : undefined
  });

  var data = null;
  var contentType = response.headers.get("content-type") || "";

  if (contentType.indexOf("application/json") > -1) {
    data = await response.json();
  } else if (response.status !== 204) {
    data = await response.text();
  }

  if (!response.ok) {
    throw createApiError(response.status, data);
  }

  return data;
}

function createApiError(status, data) {
  var error = new Error(resolveErrorMessage(status, data));
  error.status = status;
  error.data = data;
  error.validationErrors = data && data.errors ? data.errors : null;
  return error;
}

function resolveErrorMessage(status, data) {
  if (status === 422 && data && data.errors) {
    var firstKey = Object.keys(data.errors)[0];
    if (firstKey && data.errors[firstKey] && data.errors[firstKey][0]) {
      return data.errors[firstKey][0];
    }
  }

  if (data && data.message) {
    return data.message;
  }

  if (status === 401) {
    return "登录状态已失效，请重新登录。";
  }

  if (status === 500) {
    return "服务器异常，请稍后重试。";
  }

  return "请求失败，请稍后重试。";
}
